module.exports = __webpack_public_path__ + "img/6.f2c1fadd.png";